import { Env } from './constants';

export type Environment = {
    [varName in Env]: string;
};

export interface AvailableEnvironments {
    [envName: string]: Environment;
}

export interface BuildConfig {
    buildEnv: 'local' | 'development' | 'stage' | 'production';
    debugEnv: 'local' | 'development' | 'stage' | 'production';
    availableEnvironments: AvailableEnvironments;
}

// Whenever this (the default) is imported, react-native metro
// bundler will replace all references of the import with values generated from various `.env` files present at *build-time*.
// Has no use in web-app.
// Any configuration should only be consumed through ConfigService
export default {} as BuildConfig;
